import { Download, Film, ListPlus, MonitorPlay, RefreshCw, ScanSearch, type LucideIcon } from 'lucide-react'
import { isActive, useMyJobs, type JobKind, type ToolJob } from '../../api/tools'
import { formatAgo } from '../../lib/format'
import { Section } from '../Section'
import { Spinner } from '../Spinner'
import { JobResult } from './JobView'

const ICONS: Record<JobKind, LucideIcon> = {
  analyze: ScanSearch,
  reel: Film,
  youtube_probe: MonitorPlay,
  youtube: MonitorPlay,
  feed_add: ListPlus,
  // В список не попадает (сервер не отдаёт), но вид задачи есть.
  feed_refresh: RefreshCw,
}

function statusText(job: ToolJob, now: number): string {
  if (job.status === 'queued')
    return job.queue_position && job.queue_position > 1 ? `в очереди: ${job.queue_position}-я` : 'в очереди'
  if (job.status === 'running') return job.progress?.text ?? 'в работе'
  return formatAgo(job.finished_at ?? job.updated_at, now)
}

/** Задачи за сутки: можно закрыть окно и вернуться к результату. */
export function RecentJobs({ className = 'mt-6' }: { className?: string }) {
  const jobs = useMyJobs()
  const list = jobs.data ?? []
  if (list.length === 0) return null
  const now = Date.now()
  return (
    <Section title="Недавние задачи" className={className}>
      <ul className="space-y-2">
        {list.map((job) => {
          const Icon = ICONS[job.kind] ?? Download
          return (
            <li key={job.id} className="rounded-xl bg-card p-3 ring-1 ring-line">
              <div className="flex items-start gap-3">
                <span className="inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-surface text-muted ring-1 ring-line ring-inset">
                  {isActive(job) ? <Spinner size={16} /> : <Icon size={16} />}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium">{job.title}</p>
                  <p className="truncate text-xs text-muted">{statusText(job, now)}</p>
                  {!isActive(job) && (
                    <div className="mt-2">
                      <JobResult job={job} compact />
                    </div>
                  )}
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </Section>
  )
}
